import { render, staticRenderFns } from "./set-prize-activity.vue?vue&type=template&id=8dc258f0&scoped=true&"
import script from "./set-prize-activity.vue?vue&type=script&lang=js&"
export * from "./set-prize-activity.vue?vue&type=script&lang=js&"
import style0 from "./set-prize-activity.vue?vue&type=style&index=0&id=8dc258f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc258f0",
  null
  
)

export default component.exports